import React from 'react'

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  LegendItem,
  Plugin
} from 'chart.js'
import { AnyObject } from 'chart.js/types/basic'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Pie } from 'react-chartjs-2'

import { FORMAT } from 'utils'

ChartJS.register(ArcElement, Tooltip, Legend)

interface PieChartProps {
  values: [number, number, number] | null
  labels: [string, string, string] | null
}

const PieChart: React.FC<PieChartProps> = ({ values, labels }) => {
  // Oculta o "Total" do gráfico, mostra só na label abaixo dele
  const valuesExceptTotal = values ? [values[0], values[1], null] : []

  return (
    <Pie
      data={{
        datasets: [
          {
            backgroundColor: ['#004C97', '#F82D2D', '#000'],
            data: valuesExceptTotal
          }
        ],
        labels: labels
      }}
      options={{
        plugins: {
          datalabels: {
            color: '#fff',
            formatter: function (value) {
              if (!value) return '' // Oculta o "Total" (null) do gráfico
              return Math.round((value / values[2]) * 100) + '%'
            },
            labels: {
              title: {
                font: {
                  size: 20,
                  weight: 'bold'
                }
              }
            }
          },
          legend: {
            align: 'center',
            display: true,
            labels: {
              filter: (legendItem: LegendItem & { index: number }) => {
                // Muta o texto do label na legenda, ficando label + valor
                legendItem.text = `${legendItem.text} ${FORMAT.currency(values[legendItem.index], 'decimal')}`
                // Retorna true pra mostrar o label
                return true
              },
              textAlign: 'center'
            },
            position: 'bottom'
          }
        }
      }}
      plugins={[ChartDataLabels as Plugin<'pie', AnyObject>]}
    />
  )
}

export default PieChart
